export default __webpack_public_path__ + "static/media/IMG_4046.a399c163.JPG";